import { memo } from 'react'
import { ViewType } from '../../../assets/constants'
import MultiPaneMenu from '../../../components/multiPaneMenu/multiPaneMenu'
import LayoutMenu from '../../../components/layoutMenu/layoutMenu'

export type LayoutActionsProps = {
    viewType: ViewType,
    multiPaneMenuId?: string,
    layoutMenuId?: string,
    disabled?: boolean
}

const LayoutActions: React.FC<LayoutActionsProps> = ({multiPaneMenuId, layoutMenuId, disabled}) => {
    return  <>
                <MultiPaneMenu disabled={disabled} menuId={multiPaneMenuId || "tour-stock-bar-multi-pane-menu"} key="multi-pane-menu" />
                <LayoutMenu disabled={disabled} menuId={layoutMenuId || "tour-stock-bar-layout-menu"}/>
            </>;
}

export default memo(LayoutActions)
